import React, { useState } from 'react';
import Logo from '../img/logo-abella-las-dehesas-blanc.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { useScrollPosition } from '@n8tb1t/use-scroll-position';

const Header = () => {
  const [backgroundHeader, setBackgroundHeader] = useState(false);

  useScrollPosition(({ prevPos, currPos }) => {
    if (currPos.y < -50) {
      setBackgroundHeader(true);
    }

    if (currPos.y > -50) {
      setBackgroundHeader(false);
    }
  });

  return (
    <nav className={`header ${backgroundHeader ? 'header--background' : ''}`}>
      <img src={Logo} alt="Miel las dehesas" className="header__logo" />
      <a href="https://lasdehesasmiel.com" className="header__link">
        <FontAwesomeIcon icon={faArrowLeft} className="header__arrow" />
        Volver a la Web
      </a>
    </nav>
  );
};

export default Header;
